import { render, staticRenderFns } from "./BarraInferior.vue?vue&type=template&id=25655f42&scoped=true&"
import script from "./BarraInferior.vue?vue&type=script&lang=js&"
export * from "./BarraInferior.vue?vue&type=script&lang=js&"
import style0 from "./BarraInferior.vue?vue&type=style&index=0&id=25655f42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25655f42",
  null
  
)

export default component.exports